<a class="biz-card" [routerLink]="['/biz-directory', biz.id]">
    <div class="biz-card-top">
        <img *ngIf="biz.logoUrl" [src]="biz.logoUrl" class="biz-card-logo" alt="">
        <div *ngIf="!biz.logoUrl" class="rana-avatar biz-card-logo">{{ initials(biz.businessName) }}</div>
        <div class="biz-card-title">
            <div class="biz-card-name">{{ biz.businessName }}
                <i *ngIf="biz.verified" class="uil uil-check-circle biz-verified" title="Verified by RANA"></i>
            </div>
            <span class="rana-badge rana-badge-accent">{{ category(biz.industry) }}</span>
        </div>
    </div>
    <p class="biz-card-tagline" *ngIf="biz.tagline">{{ biz.tagline }}</p>
    <div class="biz-card-meta text-muted">
        <span *ngIf="location"><i class="uil uil-map-marker"></i> {{ location }}</span>
        <span *ngIf="chapterName"><i class="uil uil-users-alt"></i> {{ chapterName }}</span>
        <span *ngIf="biz.ownerName"><i class="uil uil-user"></i> {{ biz.ownerName }}</span>
    </div>
    <div class="biz-card-tags" *ngIf="biz.offerings?.length">
        <span class="biz-tag" *ngFor="let t of biz.offerings!.slice(0, 3)">{{ t }}</span>
    </div>
    <div class="biz-card-flags">
        <span class="biz-flag" *ngIf="biz.mentorAvailable"><i class="uil uil-graduation-cap"></i> Mentor</span>
        <span class="biz-flag" *ngIf="biz.memberOffer"><i class="uil uil-gift"></i> Member offer</span>
        <span class="biz-flag" *ngFor="let l of biz.lookingFor!.slice(0, 2)"><i class="uil uil-search"></i> {{ lookingFor(l) }}</span>
    </div>
    <div class="biz-card-stats text-muted">
        <span *ngIf="biz.endorsementCount"><i class="uil uil-thumbs-up"></i> {{ biz.endorsementCount }}</span>
        <span *ngIf="biz.likeCount"><i class="uil uil-heart"></i> {{ biz.likeCount }}</span>
        <span *ngIf="biz.commentCount"><i class="uil uil-comment"></i> {{ biz.commentCount }}</span>
    </div>
</a>
